import { Injectable } from '@angular/core'
import {
  AuthenticationResponseJSON,
  browserSupportsWebAuthn,
  browserSupportsWebAuthnAutofill,
  PublicKeyCredentialCreationOptionsJSON,
  PublicKeyCredentialRequestOptionsJSON,
  RegistrationResponseJSON,
  startAuthentication,
  startRegistration,
  WebAuthnAbortService,
} from '@simplewebauthn/browser'

// Dünne Hülle um @simplewebauthn/browser, damit Komponenten und Services die
// Browser-API nicht direkt aufrufen und Tests sie per DI ersetzen können
// (siehe bentomax/hawk#596).
@Injectable({
  providedIn: 'root'
})
export class WebAuthnService {

  public supportsWebAuthn(): boolean {
    return browserSupportsWebAuthn()
  }

  // Conditional UI (Passkey-Vorschläge im Autofill des E-Mail-Felds)
  public supportsAutofill(): Promise<boolean> {
    return browserSupportsWebAuthnAutofill()
  }

  // Bricht einen laufenden Aufruf selbst ab, falls vorhanden
  public startAuthentication(
    optionsJSON: PublicKeyCredentialRequestOptionsJSON,
    useBrowserAutofill = false
  ): Promise<AuthenticationResponseJSON> {
    return startAuthentication({ optionsJSON, useBrowserAutofill })
  }

  public startRegistration(optionsJSON: PublicKeyCredentialCreationOptionsJSON): Promise<RegistrationResponseJSON> {
    return startRegistration({ optionsJSON })
  }

  // Beendet einen laufenden Aufruf (z. B. den wartenden Autofill)
  public cancel(): void {
    WebAuthnAbortService.cancelCeremony()
  }
}
